export default __webpack_public_path__ + "static/angarde-02e805fd5b12bcffafee3fff1756afa9.png";